export const MAGIC = '✨✨✨✨';

export const APP_NAME = 'ClinicCareFront';

// root paths
export const EMPTY_PATH = '';
export const CREATE_PATH = 'create';
export const MANAGE_PATH = 'manage';
export const COMPLEX_PATH = 'complex';
export const ROOT_PATH = '/';
export const AUTH_PATH = 'auth';
export const AUTHENTICATE_PATH = 'authenticate';
export const LOGGED_OUT_PATH = 'logged-out';
export const SETTINGS_PATH = 'settings';
export const JOURNAL_PATH = 'documentation';
export const EDIT_PATH = 'edit';
export const DUPLICATE_PATH = 'duplicate';
export const VIEW_PATH = 'view';
export const SANDBOX_PATH = 'sandbox';
export const TEST_DASH_PATH = 'test-dashboard';
export const CHANGELOG_PATH = 'changelog';
export const USER_PROFILE_PATH = 'user-profile';
export const USER_SELECT_PATH = 'user-select';
export const NOT_FOUND = 'not-found';
export const PREVIEW_PATH = 'preview';
export const SCHEMAS_PATH = 'schemas';
export const SYMBOLS_PATH = 'symbols';
export const AREAS_PATH = 'areas';
export const SANDBOX_DRAWINGS_PATH = 'drawing-sandbox';
export const TFAPI_TEST = 'tfapi';
export const EDIT_DRAWING_PATH = 'drawing';

export const DRAWING_QP_PLACED_SYMBOL_ID = 'placedSymbolId';
export const DRAWING_QP_ADD_SCHEMA = 'addSchema';
export const DRAWING_QP_ADD_SYMBOL = 'addSymbol';

// GUARDS
export const GUARD_NAME_OVERVIEW = 'overviewModule';
export const GUARD_NAME_EDIT_ENTRY_MODULE = 'editEntryModule';
export const GUARD_NAME_EDIT_ENTRY_MODULE_ENTRYID = 'editEntryModule/:entryId';
export const GUARD_NAME_EDIT_ENTRY_EDIT = 'editEntry/edit';
export const GUARD_NAME_EDIT_ENTRY_CREATE = 'editEntry/create';
export const GUARD_NAME_EDIT_ENTRY_DRAWING = 'editEntry/drawing';
export const GUARD_NAME_TEMPLATE_MANAGE = 'template/manage';
export const GUARD_NAME_TEMPLATE_CREATE = 'template/create';
export const GUARD_NAME_TEMPLATE_EDIT = 'template/edit';
export const GUARD_NAME_TEMPLATE_DUPLICATE = 'template/duplicate';
export const GUARD_NAME_DRAWINGS_MANAGE = 'drawingsManage';

// AUTH
export const REFRESH_TOKEN = 'refresh-token';
export const REVOKE_TOKEN = 'revokeToken';
export const REVOKE_TOKEN_PATH = 'revoke-token';
export const INVALID_TOKEN = 'Invalid token';
export const TOKEN_EXPIRED = 'Token expired';
export const ACCESS_TOKEN_REFRESHED = 'Access token refreshed';


// JOURNAL
export const TEMPLATES_PATH = 'templates';
export const DRAWING_PATH = 'draw';

export const JOURNAL_TRANSLATION_SCOPE = 'journal';
export const SETTINGS_TRANSLATION_SCOPE = 'settings';
export const  COMPLEX_FIELD_TRANSLATION_SCOPE = 'complex-field-controller';
export const  FIELD_TRANSLATION_SCOPE = 'field-controller';

export const DEFAULT_THEME = 'default';
export const ICON_SIZE = '24px';
export const ICON_COLOR = '#0A3D38';

export const MODIFICATION_DATE_FORMAT = 'dd MMM yyyy - H:mm';
export const LOGGED_USER_STORE_KEY = 'logged-user';

export const UNKNOWN_TYPE_NAME = 'Unknown type';

export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_TEMPLATE_LIMIT = 12;
export const TOTAL_PAGES_NUMBER = 10;

export const BODY_ARRAY_MARKER = 'list_from';
export const OLD_ARRAY_INDEX_DELIMITER = '_';
export const DEFAULT_DATE_FORMAT = 'DD MMM YYYY';
export const DATE_FORMAT_HH_MM = 'HH:mm';
export const INVALID_DATE_FORMAT = 'invalidFormat';

export const SCROLL_DURATION = 1000;
export const SCROLL_OFFSET = -200;
export const DELAY_BEFORE_SCROLL = 250;
export const SINGLE_BLOCK_SCROLL_CONTAINER = '.scroll-container';
export const EDIT_SCROLL_CONTAINER = '.edit-container';
export const DICTATION_SECTION_SELECTOR = '.ai-dictation-section';
export const DICTATION_SCROLL_OFFSET = -15;
export const TEMP_PREVIEW_SELECTOR = '#temp-preview';
export const FIELDS_DRAG_AREA = 'fieldDragArea';
export const FIELDS_DRAG_AREA_SRC = 'fieldDragAreaSrc';
export const FIELDS_DRAG_AREA_LIST = 'fieldDragAreaList';
export const FIELDS_DRAG_AREA_LAYOUT = 'fieldDragAreaLayout';
export const FIELDS_DRAG_AREA_LAYOUT_FIRST = 'fieldDragAreaLayoutFirst';
export const FIELDS_DRAG_AREA_LAYOUT_LAST = 'fieldDragAreaLayoutLast';
export const SCHEMA_DRAG_AREA_LAYOUT = 'schemaDragAreaLayout';
export const MAX_COLUMNS_IN_LAYOUT = 12;
export const FIELD_WRAPPER_SELECTOR = '.field-wrapper';
export const TILE_WRAPPER_SELECTOR = 'journal-field-tile';
export const ROW_WRAPPER_SELECTOR = '.field-row-wrapper';
export const ROW_IN_BETWEEN_SELECTOR = '.row-in-between';
export const FIELD_LAYOUT_COMPONENT = 'journal-fields-layout';
export const FIELD_COLUMN_SELECTOR = '.field-column';
export const RESIZE_PREVIEW_SELECTOR = '.resize-row-preview';
export const FIRST_DROP_ROW_SELECTOR = '.add-row-element-first';
export const LAST_DROP_ROW_SELECTOR = '.add-row-element-last';
export const RESIZE_SELECTOR = '.resize-line';
export const LAYOUT_FIRST_ROW_ID = 'layout-first-row';
export const LAYOUT_LAST_ROW_ID = 'layout-last-row';
export const LAYOUT_IN_BETWEEN_ROW_ID = 'layout-in-between-row';
export const FIELD_CONTROLLER_ID = 'field-controller';
export const SCROLL_TO_FIELD_PREFIX = 'field-';
export const SCROLL_TOP_ID = 'scroll-top';
export const SCROLL_TOP_PATIENT = 'scroll-container';
export const SELECTOR_PREFIX = 'selector-';

export const JOURNAL_SETTINGS_KEYS_PREFIX = 'journal';
export const ENTRIES_PER_PAGE = [5, 10, 20, 50];
export const OVERVIEW_ENTRIES_LIMIT = [5, 10, 15, 20, 100];
export const MESSAGING_ANIMATION_TIME = 200;
export const MESSAGING_ANIMATION_TIME_DELAY = MESSAGING_ANIMATION_TIME * 2.1;
export const TRANSLATE_ANIMATION_TIME = 150;
export const TRANSITION_ANIMATION_TIME = '300ms';
export const DOUBLE_TRANSITION_ANIMATION_TIME = '600ms';
export const WARNING_DROPDOWN_LIMIT = 5;
export const GLOBAL_TEMPLATES_CLINIC_ID = 'bd95fd5c-3411-4927-9492-cb914ca02b12';
export const CLICK_OUTSIDE_TRIGGER = 'click-outside-trigger';

// CONTENT WITH ELLIPSIS
export const NUMBER_OF_LINES = 3;
export const CONTENT_LINES_NUMBER = [3, 5, 7, 10];
export const BTN_CLASS_PREFIX = 'btn';
export const BTN_OUTLINE_CLASS_PREFIX = 'btn-outline';
export const ICON_CLASS_PREFIX = 'icon';
export const DISABLED_CLASS = 'disabled';

// DRAWINGS
export const SCHEMA_ID_PREFIX = 'schema';
export const PLACED_SYMBOL_PREFIX = 'placed-symbol';
export const PLACED_SYMBOLS_WRAPPER = 'placed-symbols-wrapper';
export const SCHEMA_PADDING = 15;
export const SYMBOL_SIZE_RATIO = 1;
export const SYMBOL_MINXY = 2;
export const DRAWING_CANVAS_MAX_WIDTH = 800;
export const DRAWING_CANVAS_MAX_HEIGHT = 600;
export const DRAWING_PREVIEW_MAX_HEIGHT = 350;
export const DRAWING_BIG_PREVIEW_MAX_HEIGHT = 450;
export const SYMBOL_MAX_WIDTH = 30;
export const SYMBOL_MAX_HEIGHT = 30;
export const DRAW_PROPS_TO_CARRY = ['drawType', 'schemaId', 'symbolId', 'areaId', 'placedSymbolId'];
export const WHITE_SYMBOL_COLOR = '#fff';
export const PRIMARY_SYMBOL_COLOR = '#39686D';
export const GLOBAL_SYMBOL_COLOR = '#39686D54';
export const MAIN_SYMBOL_COLOR = '#0A3D38';
export const ACTIVE_SYMBOL_COLOR = '#20C997';
export const INACTIVE_SYMBOL_COLOR = '#ADB5BD';
export const ALL_PROFESSIONS = -1;
export const FEATURE_ENABLED_CLINICS = [
	GLOBAL_TEMPLATES_CLINIC_ID, // Global templates - clinic 430
	'523b8a87-82f7-4eda-afff-39cfc1c34f96',  // Clinic 1176
	'2fa16fed-3c7d-481e-8919-68d89a3847f3',  // Clinic 1156
] as string[];
